import { FC, ReactNode } from 'react';

interface ProtectedContainerProps {
  children?: ReactNode;
}

export const ProtectedContainer: FC<ProtectedContainerProps> = ({ children }) => {
  return <div className="flex h-full w-full">{children}</div>;
};
